import { makeStyles, fade } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    formulario: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    formularioTitulo: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
    },
    cartaoScroll: {
        width: '100%',
        overflowX: 'auto',
        marginTop: theme.spacing(1),
    },
    cartao: {
        width: '100%',
        minWidth: 720,
        borderCollapse: 'collapse',
        border: '1px solid #dddddd',
    },
    cartaoCelulaLabel: {
        width: 54,
        padding: theme.spacing(0.5),
        border: '1px solid #dddddd',
        backgroundColor: '#f0f0f0',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 13,
    },
    cartaoCelulaNumero: {
        padding: theme.spacing(0.5),
        border: '1px solid #dddddd',
        backgroundColor: '#f8f8f8',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 13,
    },
    cartaoCelula: {
        padding: 0,
        border: '1px solid #dddddd',
        textAlign: 'center',
    },
    cartaoCelulaSugerida: {
        backgroundColor: '#fdf3e7',
        boxShadow: 'inset 0 0 0 1px #d05d0b',
    },
    cartaoCelulaFocada: {
        outline: '2px solid #1a73e8',
        outlineOffset: -2,
    },
    cartaoRadio: {
        padding: 3,
    },
    pendentes: {
        marginTop: theme.spacing(1),
        color: '#b26500',
    },
    visualizador: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    visualizadorToolbar: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        rowGap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    visualizadorToolbarAcoes: {
        display: 'flex',
        alignItems: 'center',
        flex: '1 1 0',
        minWidth: 0,
    },
    visualizadorImagemBox: {
        position: 'relative',
        overflow: 'auto',
        minHeight: 240,
        borderRadius: 4,
        textAlign: 'center',
    },
    visualizadorLoading: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
    },
    visualizadorImagem: {
        display: 'block',
        margin: '0 auto',
        transition: 'width 0.15s ease-in-out',
    },
    visualizadorImagemRotacionada: {
        transform: 'rotate(180deg)',
    },
    visualizadorVazio: {
        padding: theme.spacing(4),
    },
    visualizadorToolbarExtra: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flex: '1 1 0',
        minWidth: 0,
    },
    visualizadorZoom: {
        display: 'flex',
        alignItems: 'center',
        flex: '0 1 320px',
        minWidth: 200,
        maxWidth: 360,
    },
    visualizadorSlider: {
        flex: 1,
        marginLeft: theme.spacing(1.5),
        marginRight: theme.spacing(1.5),
    },

    painel: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    formularioBox: {
        padding: theme.spacing(1.5),
        backgroundColor: '#ffffff',
        border: '1px solid #eeeeee',
        borderRadius: 4,
    },
    painelAcoes: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginTop: theme.spacing(2),
    },
    painelAcao: {
        marginLeft: theme.spacing(1),
    },
    painelAcaoConfirmar: {
        marginLeft: 'auto',
        '&:focus': {
            outline: 'none',
            boxShadow: `0 0 0 3px ${fade(theme.palette.primary.main, 0.45)}`,
            animationName: '$destaqueFoco',
            animationDuration: '0.9s',
            animationTimingFunction: 'ease-out',
            animationIterationCount: 3,
        },
    },
    '@keyframes destaqueFoco': {
        '0%': {
            boxShadow: `0 0 0 3px ${fade(theme.palette.primary.main, 0.6)}`,
        },
        '70%': {
            boxShadow: `0 0 0 16px ${fade(theme.palette.primary.main, 0)}`,
        },
        '100%': {
            boxShadow: `0 0 0 3px ${fade(theme.palette.primary.main, 0.6)}`,
        },
    },
    painelVazio: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(6),
        border: '1px dashed #cccccc',
        borderRadius: 4,
    },

    contador: {
        width: 260,
    },
    contadorAviso: {
        color: '#b26500',
    },
    contadorLinha: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(0.5),
    },

    dialogInvalidar: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    dialogInvalidarProva: {
        marginBottom: theme.spacing(1),
    },
}));

export default useStyles;
